<template>
    <div class="col-md-12">
        <table class="table table-bordered">
            <tr>
                <th>Tipo de Documento</th>
                <th style="width:5%">Deletar</th>
            </tr>
            <tr v-for="(tipoDocumento, index) in tipoDocumentos">
                <td>
                    <select-component :initial-value="tipoDocumento.tipo_documento_id" :name="'tipo_documentos[]'" @selected="(val) => tipoDocumento.tipo_documento_id = val"
                                      table="tipo_documentos" field-id="id"
                                      field-name="name"></select-component>
                </td>
                <td><a @click.pre.prevent.stop="deleteTipoDocumento(tipoDocumento.id, index)" class="btn btn-danger btn-sm" href="">X</a></td>
            </tr>
            <tr style="background: #e1e1e1">
                <td colspan="3">
                    <a @click.stop="addTipoDocumento" href="javascript:;" class="btn btn-sm btn-info">Adicionar Tipo de Documento</a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import TipoDocumentoModel from "../models/TipoDocumentoModel";
import FormGroup from "./FormGroup.vue";
import Checkbox from "./generics/Checkbox.vue";

export default {
    name: "TipoDocumentos",
    props: ['items'],
    components: {Checkbox, FormGroup},
    data() {
        return {
            tipoDocumentos: []
        }
    },
    mounted() {
        if (this.items.length > 0){
            this.tipoDocumentos = this.items.map((e) => e.pivot);
        }
    },
    methods: {
        addTipoDocumento() {
            this.tipoDocumentos.push(new TipoDocumentoModel())
        },
        deleteTipoDocumento(id, itemIndex) {
            if (id) {
                let app = this;
                axios.delete('/panel/tipo_processos/tipo_documento/' + id)
                    .then((response) => {
                        app.tipoDocumentos.splice(itemIndex, 1);
                    })
                    .catch(error => {
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {
                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }
                        showMessage('w', message);
                    })
            } else {
                this.tipoDocumentos.splice(itemIndex, 1);
            }

        },
    }

}
</script>

<style scoped>

</style>
